import { Injectable } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { EagerSelectEffects } from '../../select/eager-select/eager-select-effects';
import { serverOptionActions } from './server-option.actions';
import { serverOptionSelectors } from './server-option.reducer';

@Injectable({ providedIn: 'root' })
export class ServerOptionEffects {
   defaultFields: string[] = ['serverName', 'serverId'];

   defaultOrderingOptions: string[] = ['ServerId:asc'];

   staticFilters: string[] = [];

   load = this.eagerSelectEffects.createEagerSelectorLoadEffect(
      serverOptionSelectors.selectState,
      'servers',
      this.defaultFields,
      this.defaultOrderingOptions,
      serverOptionActions,
      this.staticFilters
   );

   constructor(private eagerSelectEffects: EagerSelectEffects<AppState>) {}
}
